import { useServicePriceLimits, useServicePriceError } from "@/hooks/useServicePriceLimits";
import { describeLimits } from "@/lib/service-price-limits-shared";

interface Props {
  /** Price currently in the form, WITHOUT VAT (the range is configured for that number). */
  price: number | null;
  /** Loaded price without VAT of the service being edited, if any (grandfathered). */
  savedPrice?: number | null;
}

/**
 * Helper line under a service price field: shows the admin-configured range, and
 * turns into an error when the entered price falls outside it. Renders nothing
 * when no range is configured.
 */
export function ServicePriceLimitHint({ price, savedPrice }: Props) {
  const limits = useServicePriceLimits();
  const error = useServicePriceError(price, savedPrice);
  const hint = describeLimits(limits);

  if (!hint) return null;

  return (
    <p className={error ? "text-xs text-destructive" : "text-xs text-muted-foreground"}>
      {error ?? hint}
    </p>
  );
}
